(function(){
  'use strict';
  function init(){
    document.documentElement.classList.add('yn-mobile-ready');
    var navs=document.querySelectorAll('.yn-nav,.yamn-nav,.site-nav');
    navs.forEach(function(nav){
      nav.addEventListener('wheel',function(e){
        if(Math.abs(e.deltaY)>Math.abs(e.deltaX)){nav.scrollLeft+=e.deltaY;e.preventDefault();}
      },{passive:false});
    });
    var forms=document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function(form){
      if(form.dataset.ynBound) return;
      form.dataset.ynBound='1';
      form.addEventListener('submit',function(){
        var btn=form.querySelector('button[type="submit"],input[type="submit"]');
        if(btn){btn.classList.add('is-loading');setTimeout(function(){btn.classList.remove('is-loading');},900);}
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();